import axios from '@/axios.js';
import constants from '@/constants.js';


export default {
   /*async createUser({ commit }, payload) {
       try {
           const resObj = await axios.post(`${constants.apiHost}/alex`, payload);
           const data = {
               youlabId: resObj.data.youlabId,
               youlabToken: resObj.data.youlabToken,
               userProgress: resObj.data.userProgress
           };
           commit('SET_ALEX_DATA', data);
       }
       catch (err) {
           throw err;
       }
   },*/
  async fetchDetails({ commit }, userId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/alex/${userId}`);
      const data = {
        uuId: resObj.data.uuId,
        youlabToken: resObj.data.youlabToken,
        userProgress: resObj.data.progress,
        youlabId:resObj.data.youlabId
      };
      commit('SET_ALEX_DATA', data);
      return resObj;
      // console.log({ alexData: resObj.data });

      // console.log({ alexData: resObj.data });
    }
    catch (err) {
      throw err;
    }
  },
  async getTrainingItems({ commit }, payload) {
    let filterQuery = "";
    if (payload.filters) {
      payload.filters.forEach(item => {
        filterQuery += `${item.field}[$in][]=${item.value}&`
      })
    }
    try {
      const resObj = await axios.get(`${constants.apiHost}/training-library-gala?&${filterQuery}$skip=${payload.items}`);
      commit('SET_TRAINING_LIBRARY_GALA_DATA', resObj.data.data);
      return resObj.data;
    }
    catch (err) {
      throw err;
    }
  },
  async getTestItems({ commit }, payload) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/training-library-gala?testAvailable=true&$skip=${payload.items}`);
      commit('SET_TEST_LIBRARY_GALA_DATA', resObj.data.data);
      return resObj.data;
    }
    catch (err) {
      throw err;
    }
  },
  async fetchUserSegments({ commit }, payload) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/user-segments?orgId=${payload.orgId}`);
      commit('SET_USER_SEGMENTS', resObj.data);
      return resObj.data;
    }
    catch (err) {
      throw err;
    }
  },
  async fetchAlexUser({ commit }, _id) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/alex?organizationId=${_id}`);
      commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    }
    catch (err) {
      throw err;
    }
  },
  async fetcDepartmenByAlexUser({ commit }, payload) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/alex?organizationId=${payload.organizationId}&department=${payload.department}`);
      //commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    }
    catch (err) {
      throw err;
    }
  },
  async fetchLevelByAlexUser({ commit }, payload) {
    try {
      let filterQuery = "";
      if (payload.roleTitle) {
        // // console.log(' payload.roleTitle', payload.level.length);
        for(let i=0;i< payload.level.length;i++){
          filterQuery += `lavel['label'][$in][]=${payload.level[i]}&`
        }
      }
      const resObj = await axios.get(`${constants.apiHost}/alex?organizationId=${payload.organizationId}&${filterQuery}`);
      //commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    }
    catch (err) {
      throw err;
    }
  },
  async fetchroleTitleByAlexUser({ commit }, payload) {
    try {
      let filterQuery = "";
      if (payload.roleTitle) {
        // // console.log(' payload.roleTitle', payload.roleTitle.length);
        for(let i=0;i< payload.roleTitle.length;i++){
          filterQuery += `roleTitle[$in][]=${payload.roleTitle[i]}&`
        }
      }
      const resObj = await axios.get(`${constants.apiHost}/alex?organizationId=${payload.organizationId}&${filterQuery}`);
      //commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    }
    catch (err) {
      throw err;
    }
  },
  async fetchIdentifiedGapsByAlexUser({ commit }, payload) {
    try {
      let filterQuery = "";
      if (payload.identifiedGaps) {
        // // console.log(' payload.identifiedGaps', payload.identifiedGaps.length);
        for(let i=0;i< payload.roleTitle.length;i++){
          filterQuery += `identifiedGaps[$in][]=${payload.identifiedGaps[i]}&`
        }
      }
      const resObj = await axios.get(`${constants.apiHost}/alex?organizationId=${payload.organizationId}&${filterQuery}`);
      //commit('SET_ALEX_USER_DATA', resObj.data);
      return resObj.data;
    }
    catch (err) {
      throw err;
    }
  },
  async deleteSession({ commit }, userId) {
    try {
      await axios.delete(`${constants.apiHost}/alex/${userId}`);
    } catch (err) {
      throw err;
    }
  },
  async updateAlex({ commit }, data) {
    try {
      const _id = data._id;
      const resObj = await axios.patch(`${constants.apiHost}/alex/${_id}`, data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async libraryUserDataAssign({ commit }, data){
    try {
      const   userResObj = await axios.post(`${constants.apiHost}/library`, data);
      return userResObj;
    }
    catch (error) {
      throw error;
    }
  },
  async fetchAssignedCoach({ commit }, data){
    try {
      const traineeUserId = data.userId ? data.userId : "";
      const coachResObj = await axios.get(`${constants.coachIntegrationServiceUrl}?traineeUserId=${traineeUserId}`);
      const userResObj = await axios.get(`${constants.apiHost}/users/${coachResObj.data.data[0].coachUserId}`);
      commit('SET_ASSIGNED_COACH', { ...coachResObj.data, ...userResObj.data });
      return coachResObj;
    }
    catch (error) {
      throw error;
    }
  },
  async fetchJourneyReport({ commit }, organizationId) {
    try {
      const reportResObj = await axios.get(`${constants.acticsServiceUrl}/anics/report/app/journey/${organizationId}`);
      return reportResObj.data.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchJourneyGalaClientConfiguration({ commit }) {
    try {
      const response = await axios.get(`${constants.gatewayServiceUrl}/journey/gala/client-configuration`);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchJourneyDatarmonyClientConfiguration({ commit }) {
    try {
      const response = await axios.get(`${constants.gatewayServiceUrl}/journey/datarmony/client-configuration`);
      console.log(response);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
}
